
const HeroBackground = () => {
  return (
    <>
      {/* Soft radial wash — no gradient orbs or dot grids */}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_70%_50%_at_50%_-10%,hsl(var(--primary)/0.08),transparent)]" />
      {/* Subtle bottom fade into next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent -z-10" />
    </>
  );
};

export default HeroBackground;
